<template lang="pug">
div
  modal-change-status(:concept="selectedConcept" :isVisible="isModalChangeStatusVisible" @closeModal="closeModalChangeStatus" @submit="updateStatus" :is-add='isModalAdd')
  modal-concepts(:form='selectedConcept', :is-add='isModalAdd' :isVisible="isModalConceptsVisible" @closeModal="closeModalConcepts" @updateRecords="updateTable")
  vm-table.table(max-height="350px" :data="concepts" )
    template(slot="thead")
      vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('concepts.' + column) }}
    template(slot-scope="{data}")
      vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data" v-if="isProjectConcept(data[indextr]['conceptable_type'])")
        vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
          slot(v-if="column !== 'status'&& column != 'date' && column != 'charge' && column != 'payment'") {{ concepts[indextr][column] }}
          slot(v-if="column == 'date'")  {{ data[indextr][column] | moment("DD MMMM YYYY").toUpperCase() }}
          slot(v-if="column == 'charge' || column == 'payment'")  {{ data[indextr][column] | currency }}
          vm-status-indicator(v-if="column == 'status'" :pulse="true" :color="statusColor(data[indextr][column])") {{ data[indextr][column] === 1 ? $t('projects_dashboard.payed')  : $t('projects_dashboard.invoiced_mayus')  }}
        vm-td
        vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click v-if="isConceptValid(data[indextr]) == 1")
          vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
          vm-dropdown-menu
            vm-dropdown-item.d-flex.justify-content-between(@click="showModalChangeStatus(data[indextr])")
              vm-icon(icon="checkmark-circle-outline")
              slot &nbsp;{{ $t('strings.change_status') }}
            vm-dropdown-item.d-flex.justify-content-between(@click="updateConcept(data[indextr], tr)")
              vm-icon(icon="edit-2-outline")
              slot &nbsp;{{ $t('strings.edit') }}
            vm-dropdown-item.d-flex.justify-content-between(@click="deleteConceptConfirm(data[indextr])")
              vm-icon(icon="trash-2-outline")
              slot &nbsp;{{ $t('strings.delete') }}
  vm-pagination.pagination(:total="pagination.totalPages" v-model="currentPage" goto)
</template>

<script>
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ConceptableConcepts')
const ModalConcepts = () => import('@/components/modals/ModalConcepts.vue')
const ModalChangeStatus = () => import('@/components/modals/ModalChangeConceptStatus.vue')

export default {
  components: {
    ModalConcepts,
    ModalChangeStatus
  },
  data: () => ({
    currentPage: 1,
    date: '',
    columns: ['date', 'concept', 'payment', 'charge', 'status'],
    attributeModal: 'concept',
    filters: {
      where: {
        conceptable_id: null,
        conceptable_type: 'App\\Models\\Project'
      }
    },
    isModalAdd: true,
    isModalChangeStatusVisible: false,
    isModalConceptsVisible: false,
    selectedConcept: null
  }),
  computed: {
    ...mapGetters([
      'concepts',
      'pagination'
    ])
  },
  watch: {
    async currentPage (value) {
      this.loadRecords({ page: value })
    }
  },
  async created () {
    this.filters = {
      where: {
        conceptable_id: '=' + this.$route.params.id
      }
    }
    this.applyFilter(this.filters)
    await this.loadRecords({ page: this.currentPage })
  },
  methods: {
    ...mapActions([
      'deleteRecord',
      'loadRecords',
      'applyFilter',
      'editConcept',
      'editRecord'
    ]),
    isProjectConcept(concept) {
      return concept == 'App\\Models\\Project'
    },
    isConceptValid (concept) {
      return ((moment(concept.date).format('YYYY-MM') === moment().format('2022-12') || moment(concept.date).format('YYYY') > 2022)) ? 1 : 0
    },
    statusColor (status) {
      return status === 1 ? 'success' : 'warning'
    },
    showModalChangeStatus (concept) {
      this.isModalAdd = false
      this.selectedConcept = { ...concept }
      this.isModalChangeStatusVisible = true
    },
    closeModalChangeStatus () {
      this.isModalChangeStatusVisible = false
    },
    async updateStatus (form) {
      this.editRecord({ ...this.selectedConcept, ...form })
      this.$emit('updateStatistics')
    },
    updateConcept (concept) {
      this.selectedConcept = { ...concept, payment: parseFloat(concept.payment).toFixed(2), charge: parseFloat(concept.charge).toFixed(2) }
      this.isModalAdd = false
      this.isModalConceptsVisible = true
    },
    closeModalConcepts () {
      this.isModalConceptsVisible = false
    },
    updateTable (concept) {
      this.editConcept({ ...concept })
      this.$emit('updateStatistics')
    },
    async deleteConceptConfirm (record) {
      let t = this
      this.auxDeleteRecord = async () => {
        await t.deleteRecord({ ...record }).then(() => {
          this.$emit('updateStatistics')
          t.selected = []
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation2', {
          model: this.$t('strings.concept'),
          attribute: this.$t(record[this.attributeModal])
        }),
        accept: this.auxDeleteRecord
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import './project_dashboard_structure.css';
</style>
